import shortid from "shortid"
import Geometry from "@frog/source/utility/Geometry.js"
import * as Motions from "@frog/source/utility/Motions.js"
import Timings from "@frog/source/utility/Timings.js"
import Keyset from "@frog/source/utility/Keyset.js"
import Unit from "@frog/source/models/Unit.js"

const animations = {}
export default animations

animations["default"] = (step) => {
    let keyframes = []
    step.deltastages.forEach((deltastage) => {
        Keyset.forEach(deltastage.units, (deltaunit, unitKey) => {
            keyframes.push({
                "mark": 0,
                "key": unitKey
            })
            const superdeltaunit = {
                "key": unitKey,
                "mark": 250,
            }
            if(deltaunit.position != undefined
            && deltaunit.mode != "absolute") {
                superdeltaunit.position = deltaunit.position
            }
            if(deltaunit.health != undefined) {
                superdeltaunit.health = deltaunit.health
            }
            keyframes.push(superdeltaunit)
        })
    })

    return { keyframes }
}

animations["move"] = (step) => {
    const keyframes = []
    step.deltastages.forEach((deltastage) => {
        Keyset.forEach(deltastage.units, (unit, unitKey) => {
            const a = step.alphastage.units[unitKey].position
            const b = step.omegastage.units[unitKey].position
            keyframes.push({
                "key": unitKey,
                "mark": 0,
                "position": Geometry.zero(),
            })
            // keyframes.push({
            //     "type": "audio",
            //     "mark": 0,
            //     "audio": {"triggerKey": "Unit:Move"},
            // })
            keyframes.push({
                "key": unitKey,
                "mark": 150,
                "timing": Timings.easeOutQuad,
                "event": "onEnd",
                "position": {
                    "x": b.x - a.x,
                    "y": b.y - a.y,
                    "z": b.z - a.z,
                },
            })
        })
    })
    return { keyframes }
}

animations["death"] = (step) => {
    let keyframes = []
    step.deltastages.forEach((deltastage) => {
        if(deltastage.annotation == undefined
        || deltastage.annotation.type == "death-by-damage") {
            Object.keys(deltastage.units).forEach((unitKey) => {
                keyframes = keyframes.concat([
                    {
                        "key": unitKey,
                        "mark": 0,
                        "position": Geometry.zero(),
                        "opacity": 1,
                    },
                ])
                for(let i = 0; i < 1; i += 0.1) {
                    keyframes.push({
                        "mark": 0 + (i * 500),
                        "key": unitKey,
                        "timing": Timings.jump,
                        "position": {
                            "x": Random.range(-0.25, 0.25),
                            "y": Random.range(-0.25, 0.25),
                        },
                    })
                }
                keyframes = keyframes.concat([
                    {
                        "type": "audio",
                        "mark": 0,
                        "audio": {"triggerKey": "Unit:Death"},
                    },
                    {
                        "key": unitKey,
                        "mark": 500 + 25,
                        "opacity": 1,
                    },
                    {
                        "key": unitKey,
                        "mark": 500 + 25 + 200,
                        "opacity": 0,
                    }
                ])
            })
        }
        if(deltastage.annotation.type == "death-by-falling") {
            Object.keys(deltastage.units).forEach((unitKey) => {
                keyframes = keyframes.concat([
                    {
                        "type": "audio",
                        "mark": 0,
                        "audio": {"triggerKey": "Unit:Death:Falling"},
                    },
                    {
                        "key": unitKey,
                        "mark": 0,
                        "position": Geometry.zero(),
                        "opacity": 1,
                    },
                    {
                        "key": unitKey,
                        "mark": 400,
                        "timing": Timings.easeInQuad,
                        "position": {"z": -5},
                    },
                    {
                        "key": unitKey,
                        "mark": 200,
                        "opacity": 1
                    },
                    {
                        "key": unitKey,
                        "mark": 400,
                        "timing": Timings.linear,
                        "opacity": 0
                    },
                    {
                        "key": unitKey,
                        "mark": 0,
                        "rotation": 0
                    },
                    {
                        "key": unitKey,
                        "mark": 400,
                        "timing": Timings.easeInQuad,
                        "rotation": 60
                    },
                ])
                // for(let i = 0; i < 1; i += 0.1) {
                //     keyframes.push({
                //         "mark": 0 + (i * 200),
                //         "key": unitKey,
                //         // "timing": Timings.jump,
                //         "position": {
                //             "x": Random.range(-0.25, 0.25),
                //             "y": Random.range(-0.25, 0.25),
                //         },
                //     })
                // }
            })
        }
    })
    return { keyframes }
}

animations["escape"] = (step) => {
    let keyframes = []
    step.deltastages.forEach((deltastage) => {
        if(deltastage.annotation.startPosition != undefined) {
            Object.keys(deltastage.units).forEach((unitKey) => {
                keyframes = keyframes.concat([
                    {
                        "key": unitKey,
                        "mark": 0,
                        "position": deltastage.annotation.startPosition
                    },
                    {
                        "type": "audio",
                        "mark": 0,
                        "audio": {"triggerKey": "Unit:Escape"},
                    },
                    {
                        "key": unitKey,
                        "mark": 500,
                        "timing": Timings.easeInQuad,
                        "motion": Motions.arc(),
                        "position": {
                            "x": 5, "y": 6, "z": 1,
                            "mode": "absolute"
                        }
                    },
                    {
                        "key": unitKey,
                        "mark": 1000,
                        "timing": Timings.easeOutQuad,
                        "position": {
                            "x": 5, "y": 6, "z": -5,
                            "mode": "absolute"
                        }
                    },
                    // {
                    //     "key": unitKey,
                    //     "mark": 100,
                    //     "timing": Timings.easeInQuad,
                    //     "position": {
                    //         "x": 5, "y": 5, "mode": "absolute",
                    //     }
                    // },
                ])
            })
        }
    })
    return { keyframes }
}

class Random {
    static sign() {
        return Math.random() < 0.5 ? -1 : +1
    }
    static range(min, max) {
        return (Math.random() * (max - min)) + min
    }
}
animations["explode"] = (step) => {
    const CENTER_OFFSET = {"x": -0.5, "y": -0.5, "z": 0.2}
    let keyframes = []
    step.deltastages.forEach((deltastage) => {
        if(deltastage.annotation == undefined) {
            return
        }
        if(deltastage.annotation.type == "remove") {
            Keyset.forEach(deltastage.units, (unit, unitKey) => {
                keyframes.push({
                    "mark": deltastage.annotation.distance * 100,
                    "key": unitKey,
                    "health": unit.health,
                    "isDead": unit.isDead,
                    "opacity": 0,
                })
            })
        }
        if(deltastage.annotation.type == "explode") {
            for(let i = 0; i < 10; i += 1) {
                const key = shortid.generate()
                const scale = 1.5 + (Math.random() * 1)
                keyframes.push({
                    "mark": (deltastage.annotation.distance * 50) + (Math.random() * 100),
                    "key": key,
                    "type": "particle",

                    "scale": scale,
                    "image": require("@frog/source/images/dot.png"),
                    "position": Geometry.add(deltastage.annotation.position, CENTER_OFFSET, {
                        "x": (Random.range(0, 0.4)) * Random.sign(),
                        "y": (Random.range(0, 0.4)) * Random.sign(),
                    }),
                })
                keyframes.push({
                    "mark": (deltastage.annotation.distance * 150) + 500,
                    "key": key,
                    "type": "particle",
                    // "timing": Timings.bezier(0.3, 1-0.25, 1-0.3, 0.25),
                    // "motion": Motions.arc(),

                    "scale": 0,
                    "image": require("@frog/source/images/dot.png"),
                    "delete": true,
                })
            }
            Keyset.forEach(deltastage.units, (unit, unitKey) => {
                keyframes.push({
                    "mark": deltastage.annotation.distance * 100,
                    "key": unitKey,
                    "health": unit.health,
                    "isDead": unit.isDead,
                    "opacity": 0,
                })
            })
        }
    })
    return { keyframes }
}

animations["exhaust energy"] = (step) => {
    let keyframes = []
    step.deltastages.forEach((deltastage) => {
        Object.keys(deltastage.units).forEach((unitKey) => {
            keyframes = keyframes.concat([
                {
                    "key": unitKey,
                    "mark": 0,
                    "timing": Timings.easeInQuad,
                    "grayscale": 0,
                },
                {
                    "key": unitKey,
                    "mark": 500,
                    "timing": Timings.easeInQuad,
                    "grayscale": 1,
                },
            ])
        })
    })
    return { keyframes }
}

// TODO: the other marks should be relative to the hit mark, yeah?
// and should allow some amount of delay. this should apply for all
// these reusable sub-animation bits.
function swingAnimation(unitKey, direction, hitMark) {
    return [
        {
            "key": unitKey,
            "mark": 0,
            "position": Geometry.zero(),
        },
        {
            "key": unitKey,
            "mark": 150,
            "position": {"x": -0.25 * direction.x, "y": -0.25 * direction.y},
        },
        {
            "key": unitKey,
            "mark": 250,
            "position": {"x": -0.25 * direction.x, "y": -0.25 * direction.y},
        },
        {
            "key": unitKey,
            "mark": hitMark,
            "position": {"x": +0.125 * direction.x, "y": +0.125 * direction.y},
        },
        {
            "key": unitKey,
            "mark": hitMark + 50,
            "position": {"x": +0.125 * direction.x, "y": +0.125 * direction.y},
        },
        {
            "key": unitKey,
            "mark": hitMark + 150,
            "position": Geometry.zero(),
        }
    ]
}

function spinAnimation(deltastage, hitMark) {
    const unitKey = deltastage.annotation.performerKey
    const direction = deltastage.annotation.direction
    let facing = -1
    if(Geometry.equals(direction, Geometry.directions.north)
    || Geometry.equals(direction, Geometry.directions.east)) {
        facing = +1
    }
    return [
        {
            "key": unitKey,
            "mark": 0,
            "position": Geometry.zero(),
            "rotation": 0,
        },
        {
            "key": unitKey,
            "mark": 150,
            "position": {"x": -0.25 * direction.x, "y": -0.25 * direction.y},
            "rotation": 15 * facing,
        },
        {
            "key": unitKey,
            "mark": 250,
            "position": {"x": -0.25 * direction.x, "y": -0.25 * direction.y},
            "rotation": 15 * facing,
        },
        {
            "key": unitKey,
            "mark": hitMark,
            "position": {"x": +0.125 * direction.x, "y": +0.125 * direction.y},
            "rotation": 15 * 1.2 * facing,
        },
        {
            "key": unitKey,
            "mark": hitMark + 50,
            "position": {"x": +0.125 * direction.x, "y": +0.125 * direction.y},
            "rotation": 15 * 1.2 * facing,
        },
        {
            "key": unitKey,
            "mark": hitMark + 150,
            "position": Geometry.zero(),
            "rotation": 0
        }
    ]
}

const effectivenessSounds = {
    "-1": "Unit:Damage:Poor",
    "0": "Unit:Damage:Normal",
    "1": "Unit:Damage:Great",
}
const effectivenessImages = {
    // "-1": require("@frog/source/images/damage/poor-damage.png"),
    // "0": require("@frog/source/images/damage/normal-damage.png"),
    // "1": require("@frog/source/images/damage/great-damage.png"),
}
const particleImages = {
    // TODO: add 0-damage sprite!!
    // "-1": require("@frog/source/images/damage/1.png"),
    // "-2": require("@frog/source/images/damage/2.png"),
    // "-3": require("@frog/source/images/damage/3.png"),
    // "-4": require("@frog/source/images/damage/4.png"),
    // "-5": require("@frog/source/images/damage/5.png"),
}
function bumpAnimation(unitKey, direction, hitMark, deltahealth = 0, annotation, step, deltastage) {
    const frames = [
        {
            "key": unitKey,
            "mark": hitMark,
            "health": 0,
            "position": Geometry.zero(),
        },
        {
            "key": unitKey,
            "mark": hitMark + 150,
            "health": deltahealth,
            "position": {
                "x": 0.25 * direction.x,
                "y": 0.25 * direction.y
            },
            "timing": Timings.easeOutQuad,
        },
        {
            "key": unitKey,
            "mark": hitMark + 300,
            "position": {"x": 0, "y": 0},
            "timing": Timings.easeOutQuad,
        },
    ]
    if(step != undefined) {
        // frames.push({
        //     "key": "log",
        //     "type": "log",
        //     "mark": hitMark,
        //     "text": (step.alphastage.units[unitKey].name || "Box") + " takes " + (-1 * deltahealth) + " damage"
        // })

        // DAMAGE PARTICLE //
        if(particleImages[deltahealth] != undefined
        && step.omegastage.units[unitKey] != undefined) {
            const key = shortid.generate()
            const startingPosition = Geometry.add(step.omegastage.units[unitKey].position, {"x": -0.5, "y": -0.5, "z": 1})
            frames.push({
                "mark": hitMark,
                "key": key,
                "type": "particle",
                "image": require("@frog/source/images/damage.png"), // particleImages[deltahealth],
                "position": startingPosition,
            })
            frames.push({
                "mark": hitMark + 600,
                "key": key,
                "type": "particle",
                "timing": Timings.easeOutQuad,
                "position": Geometry.add(startingPosition, {"z": +0.4}),
                "delete": true,
            })

            if(annotation != undefined
            && annotation.effectiveness !== undefined
            && effectivenessImages[annotation.effectiveness] != undefined) {
                const key2 = shortid.generate()
                frames.push({
                    "mark": hitMark,
                    "key": key2,
                    "type": "particle",
                    "image": effectivenessImages[annotation.effectiveness],
                    "position": Geometry.add(startingPosition, {"z": -0.1}),
                })
                frames.push({
                    "mark": hitMark + 600,
                    "key": key2,
                    "type": "particle",
                    "timing": Timings.easeOutQuad,
                    "position": Geometry.add(startingPosition, {"z": +0.4 + -0.1}),
                    "delete": true,
                })
            }
        }
    }
    // EFFECTIVENESS SOUND //
    if(annotation != undefined
    && annotation.effectiveness !== undefined
    && effectivenessSounds[annotation.effectiveness] != undefined) {
        frames.push({
            "type": "audio",
            "mark": hitMark,
            "audio": {"triggerKey": effectivenessSounds[annotation.effectiveness]},
            // "audio": {
            //     "source": require("@frog/source/assets/sounds/pokemon/normal-damage.wav"),
            //     "volume": 0.5,
            // },
        })
    }
    return frames
}

function pushAnimation(unitKey, annotation, hitMark, deltaunit) {
    return [
        {
            "key": unitKey,
            "mark": hitMark,
            "position": Geometry.zero(),
        },
        {
            "key": unitKey,
            "mark": hitMark + 300,
            "position": {
                "x": deltaunit.position.x,
                "y": deltaunit.position.y,
            },
            "timing": Timings.easeOutQuad,
        },
        // {
        //     "key": unitKey,
        //     "mark": hitMark + 300,
        //     "position": {"x": 0, "y": 0},
        //     "timing": Timings.easeOutQuad,
        // }
    ]
}

function suplexAnimation(unitKey, annotation, hitMark, deltaunit) {
    return [
        {
            "key": unitKey,
            "mark": hitMark,
            "position": Geometry.zero(),
        },
        {
            "key": unitKey,
            "mark": hitMark + 300,
            "position": {
                "x": deltaunit.position.x,
                "y": deltaunit.position.y,
            },
            "motion": Motions.arc(2),
            "timing": Timings.linear,
        },
        // {
        //     "key": unitKey,
        //     "mark": hitMark + 300,
        //     "position": {"x": 0, "y": 0},
        //     "timing": Timings.easeOutQuad,
        // }
    ]
}

animations["strike"] = (step) => {
    let keyframes = []
    const hitMark = 300
    const HIT_MARK = hitMark
    step.deltastages.forEach((deltastage) => {
        if(deltastage.annotation != undefined) {
            if(deltastage.annotation.type == "spin") {
                keyframes = keyframes.concat(spinAnimation(deltastage, hitMark))
            }
        }
        if(deltastage.annotation.type == "nudge") {
            console.log(deltastage.annotation)
            keyframes = keyframes.concat([
                {
                    "key": deltastage.annotation.unitKey,
                    "mark": HIT_MARK,
                    "position": Geometry.zero(),
                },
                {
                    "key": deltastage.annotation.unitKey,
                    "mark": HIT_MARK + 150,
                    "position": {
                        "x": 0.25 * deltastage.annotation.direction.x,
                        "y": 0.25 * deltastage.annotation.direction.y
                    },
                    "timing": Timings.easeOutQuad,
                },
                {
                    "key": deltastage.annotation.unitKey,
                    "mark": HIT_MARK + 300,
                    "position": Geometry.zero(),
                    "timing": Timings.easeOutQuad,
                },
            ])
        }
        Keyset.forEach(deltastage.units, (deltaunit, unitKey) => {
            if(deltastage.annotation == undefined) {
                return
            }
            if(deltastage.annotation.type == "swing") {
                keyframes = keyframes.concat(swingAnimation(unitKey, deltastage.annotation.direction, hitMark))
                if(deltastage.annotation.unit == "flipper") {
                    keyframes.push({
                        "type": "audio",
                        "mark": hitMark,
                        "audio": {"triggerKey": "Flipper:Swing"},
                    })
                }
                if(deltastage.annotation.unit == "pusher") {
                    keyframes.push({
                        "type": "audio",
                        "mark": hitMark,
                        "audio": {"triggerKey": "Pusher:Swing"},
                    })
                }
                if(deltastage.annotation.unit == "robot") {
                    keyframes.push({
                        "type": "audio",
                        "mark": hitMark,
                        "audio": {"triggerKey": "Robot:Swing"},
                    })
                }
            }
            if(deltastage.annotation.type == "inflict damage") {
                keyframes = keyframes.concat(bumpAnimation(unitKey, deltastage.annotation.direction, hitMark, deltaunit.health, deltastage.annotation, step, deltastage))
            }
            if(deltastage.annotation.type == "push") {
                keyframes = keyframes.concat(pushAnimation(unitKey, deltastage.annotation, hitMark, deltaunit))
            }
            if(deltastage.annotation.type == "suplex") {
                keyframes = keyframes.concat(suplexAnimation(unitKey, deltastage.annotation, hitMark, deltaunit))
            }
        })
    })
    return {keyframes}
}

animations["hook"] = (step) => {
    const hitMark = 300
    const OFFSET = {"x": -0.5, "y": -0.5, "z": 0.1}

    let keyframes = []
    step.deltastages.forEach((deltastage) => {
        if(deltastage.annotation == undefined) {
            return
        }
        if(deltastage.annotation.type == "swing") {
            keyframes = keyframes.concat(swingAnimation(deltastage.annotation.performerKey, deltastage.annotation.direction, hitMark))
            keyframes.push({
                "type": "audio",
                "mark": hitMark,
                "audio": {"triggerKey": "Puller:Throw"},
            })
        }
        // if(deltastage.annotation.type == "pull-back") {
        //     // keyframes = keyframes.concat(bumpAnimation(unitKey, deltastage.annotation.direction, hitMark, deltaunit.health, deltastage.annotation, step, deltastage))
        // }

        if(deltastage.annotation.type == "nudge") {
            const PULLING_MARK = 150 // hitMark // + (deltastage.annotation.distance * 80) + (200 - 50)
            console.log(PULLING_MARK, deltastage.annotation.unitKey, deltastage.annotation.direction)
            keyframes = keyframes.concat([
                {
                    "key": deltastage.annotation.unitKey,
                    "mark": PULLING_MARK,
                    "position": Geometry.zero(),
                },
                {
                    "key": deltastage.annotation.unitKey,
                    "mark": PULLING_MARK + 150,
                    "position": Geometry.multiply(deltastage.annotation.direction, -0.25),
                    "timing": Timings.easeOutQuad,
                },
                {
                    "key": deltastage.annotation.unitKey,
                    "mark": PULLING_MARK + 300,
                    "position": Geometry.zero(),
                    "timing": Timings.easeOutQuad,
                },
            ])
        }
        if(deltastage.annotation.type == "pull-target"
        || deltastage.annotation.type == "pull-self"
        || deltastage.annotation.type == "pull-none") {
            // HOOK PARTICLE
            const key = shortid.generate()
            const omegaposition = Geometry.add(
                deltastage.annotation.alphaposition,
                Geometry.multiply(deltastage.annotation.swingdirection, deltastage.annotation.distance),
            )
            keyframes = keyframes.concat([
                {
                    "key": key,
                    "type": "particle",
                    "mark": hitMark + 0,
                    "image": require("@frog/source/images/ld47/characterUnit2_hook.png"),
                    "position": Geometry.add(deltastage.annotation.alphaposition, OFFSET),
                    "rotation": 0,
                    // "scale": 2,
                },
                {
                    "key": key,
                    "type": "particle",
                    "mark": hitMark + (deltastage.annotation.distance * 80),
                    "timing": Timings.linear,
                    "position": Geometry.add(omegaposition, OFFSET), // TODO: Particle positions are absolute value, but unit positions are relative :X
                    "rotation": (deltastage.annotation.distance * (360 * 0.5)),
                },
            ])
            if(deltastage.annotation.type == "pull-target") {
                keyframes = keyframes.concat([
                    {
                        "key": key,
                        "type": "particle",
                        "mark": hitMark + (deltastage.annotation.distance * 80) + (200 - 50),
                        "position": Geometry.add(omegaposition, OFFSET),
                    },
                    {
                        "key": key,
                        "type": "particle",
                        "mark": hitMark + (deltastage.annotation.distance * 80) + (200 - 50) + (deltastage.annotation.distance * 40),
                        "timing": Timings.easeInQuad,
                        "position": Geometry.add(deltastage.annotation.alphaposition, OFFSET),

                    },
                    {
                        "type": "audio",
                        "mark": hitMark + (deltastage.annotation.distance * 80) + (200 - 50),
                        "audio": {"triggerKey": "Puller:Pull"},
                    }
                ])
            }
            // CHAIN PARTICLES
            for(let i = 0.5; i < deltastage.annotation.distance; i += 0.5) {
                const key = shortid.generate()
                const omegaposition = Geometry.add(
                    deltastage.annotation.alphaposition,
                    Geometry.multiply(deltastage.annotation.swingdirection, i),
                )
                keyframes = keyframes.concat([
                    {
                        "key": key,
                        "type": "particle",
                        "mark": hitMark + 0,
                        "image": require("@frog/source/images/ld47/characterUnit2_chain.png"),
                        "position": Geometry.add(deltastage.annotation.alphaposition, OFFSET),
                        "rotation": 0,
                    },
                    {
                        "key": key,
                        "type": "particle",
                        "mark": hitMark + (deltastage.annotation.distance * 80),
                        "timing": Timings.linear,
                        "position": Geometry.add(omegaposition, OFFSET),
                        "rotation": (deltastage.annotation.distance * (360 * 0.75)),
                    },
                    {
                        "key": key,
                        "type": "particle",
                        "mark": hitMark + (deltastage.annotation.distance * 80) + (200 - 50),
                        "position": Geometry.add(omegaposition, OFFSET),
                    },
                ])
                if(deltastage.annotation.type == "pull-target") {
                    keyframes = keyframes.concat([
                        {
                            "key": key,
                            "type": "particle",
                            "mark": hitMark + (deltastage.annotation.distance * 80) + (200 - 50) + (deltastage.annotation.distance * 40),
                            "timing": Timings.easeInQuad,
                            "position": Geometry.add(deltastage.annotation.alphaposition, OFFSET),
                        },
                    ])
                } else if(deltastage.annotation.type == "pull-self") {
                    keyframes = keyframes.concat([
                        {
                            "key": key,
                            "type": "particle",
                            "mark": hitMark + (deltastage.annotation.distance * 80) + (200 - 50) + (deltastage.annotation.distance * 40),
                            "timing": Timings.easeInQuad,
                            "position": Geometry.add(deltastage.annotation.omegaposition, OFFSET),
                        },
                        {
                            "type": "audio",
                            "mark": hitMark + (deltastage.annotation.distance * 80) + (200 - 50),
                            "audio": {"triggerKey": "Puller:Pull"},
                        }
                    ])
                }
            }
            // UNIT BEING PULLED
            if(deltastage.annotation.type == "pull-target"
            || deltastage.annotation.type == "pull-self") {
                keyframes = keyframes.concat([
                    {
                        "key": deltastage.annotation.targetKey,
                        "mark": hitMark + (deltastage.annotation.distance * 80) + 200,
                        "position": Geometry.zero(),
                    },
                    {
                        "key": deltastage.annotation.targetKey,
                        "mark": hitMark + (deltastage.annotation.distance * 80) + 200 + (deltastage.annotation.distance * 40),
                        "timing": Timings.easeInQuad,
                        "position": {
                            "x": deltastage.annotation.deltaposition.x,
                            "y": deltastage.annotation.deltaposition.y,
                        },
                    }
                ])
            }
        }
    })
    return {keyframes}
}

animations["rockthrow"] = (step) => {
    let keyframes = []
    const swingMark = 300
    const distance = 3 // TODO: CALCULATE THIS INTELLIGENTLY FROM ACTUAL DISTANCE
    const bumpMark = swingMark + (25 * distance)
    step.deltastages.forEach((deltastage) => {
        Keyset.forEach(deltastage.units, (deltaunit, unitKey) => {
            if(deltastage.annotation == undefined) {
                return
            }
            if(deltastage.annotation.type == "swing") {
                keyframes = keyframes.concat(swingAnimation(unitKey, deltastage.annotation.direction, swingMark))
            }
            if(deltastage.annotation.type == "throw") {
                const createUnit = Unit.copy(deltaunit)
                createUnit.mode = "create"
                createUnit.position = deltastage.annotation.startPosition
                keyframes.push({
                    "mark": swingMark,
                    "key": deltaunit.key,
                    "createUnit": createUnit, // TODO: ??!??!?!?!? is this really the api
                })
                keyframes.push({
                    "mark": swingMark,
                    "key": deltaunit.key,
                    "position": Geometry.zero()
                })
                keyframes.push({
                    "mark": bumpMark,
                    "key": deltaunit.key,

                    "timing": Timings.linear,
                    "position": deltastage.annotation.vector,
                })
            }
            if(deltastage.annotation.type == "bump") {
                keyframes = keyframes.concat(bumpAnimation(unitKey, deltastage.annotation.direction, bumpMark, deltaunit.health, deltastage.annotation))
            }
        })
    })
    return {keyframes}
}


animations["farstrike"] = (step) => {
    const distance = 2 // TODO: calculate this! and as a magnitude, not a vector.
    const FIRE_MARK = 500
    const HIT_MARK = FIRE_MARK + (300 * distance)
    const CENTER_OFFSET = {"x": -0.5, "y": -0.5, "z": 0.2}
    let keyframes = []
    step.deltastages.forEach((deltastage) => {
        if(deltastage.annotation == undefined) {
            // TODO: Just do it niavely and log about it to complain.
            return
        }
        if(deltastage.annotation.type == "cast projectile"
        || deltastage.annotation.type == "swing") {
            // TODO: Is it fine to not read the data from the
            // stage schema but entirely from the annotation?

            keyframes.push({
                "type": "audio",
                "mark": FIRE_MARK,
                "audio": {"triggerKey": "Aoe-er:Shoot"},
            })

            keyframes.push({
                "mark": 0,
                "key": deltastage.annotation.unitKey,
                "position": Geometry.zero(),
            })
            keyframes.push({
                "mark": 200,
                "key": deltastage.annotation.unitKey,
                // "position": {"x": +0.125 * direction.x, "y": +0.125 * direction.y},
                "position": {"z": -0.125},
                "timing": Timings.easeOutQuad,
            })
            keyframes.push({
                "mark": 300,
                "key": deltastage.annotation.unitKey,
                // "position": {"x": +0.125 * direction.x, "y": +0.125 * direction.y},
                "position": {"z": -0.125},
                "timing": Timings.easeOutQuad,
            })
            keyframes.push({
                "mark": FIRE_MARK,
                "key": deltastage.annotation.unitKey,
                // "position": {"x": -0.25 * direction.x, "y": -0.25 * direction.y},
                "position": {"z": 0},
                "timing": Timings.easeOutQuad,
            })
            // keyframes.push({
            //     "mark": FIRE_MARK + 200,
            //     "key": deltastage.annotation.unitKey,
            //     "position": {"x": 0, "y": 0, "z": 0},
            //     "timing": Timings.easeOutQuad,
            // })

            if(deltastage.annotation.startPosition != undefined
            && deltastage.annotation.endPosition != undefined) {
                const thing = [0, 1, 2, 3, 4, 5].forEach((index) => {
                    const key = shortid.generate()
                    keyframes.push({
                        "mark": FIRE_MARK + (33 * index),
                        "key": key,
                        "type": "particle",

                        "scale": 1 - (0.1 * index),
                        "image": require("@frog/source/images/ld47/characterUnit4_swirl.png"),
                        "position": Geometry.add(deltastage.annotation.startPosition, CENTER_OFFSET),
                        "rotation": Math.random() * 360,
                    })
                    keyframes.push({
                        "mark": HIT_MARK + (33 * index),
                        "key": key,
                        "type": "particle",
                        "timing": Timings.bezier(0.3, 1-0.25, 1-0.3, 0.25),
                        "motion": Motions.arc(),

                        "image": require("@frog/source/images/ld47/characterUnit4_swirl.png"),
                        "position": Geometry.add(deltastage.annotation.endPosition, CENTER_OFFSET),
                        "rotation": 360 * 5,
                        "delete": true,
                    })
                })
            }
        }

        if(deltastage.annotation.type == "inflict damage") {
            Keyset.forEach(deltastage.units, (deltaunit, unitKey) => {
                keyframes.push({
                    "key": unitKey,
                    "mark": 0,
                    "health": 0,
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": HIT_MARK,
                    "health": deltaunit.health,
                    "timing": Timings.easeOutQuad,
                    "position": Geometry.zero(),
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": HIT_MARK + 100,
                    "position": {"x": 0.25 * deltastage.annotation.direction.x, "y": 0.25 * deltastage.annotation.direction.y},
                    "timing": Timings.easeOutQuad,
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": HIT_MARK + 300,
                    "position": {"x": 0, "y": 0},
                    "timing": Timings.easeOutQuad,
                })
                // keyframes.push({
                //     "key": "log",
                //     "type": "log",
                //     "mark": HIT_MARK,
                //     "text": (step.alphastage.units[unitKey].name || "Box") + " takes " + (-1 * deltaunit.health) + " damage"
                // })
                // DAMAGE PARTICLE //
                if(particleImages[deltaunit.health] != undefined
                && step.omegastage.units[unitKey] != undefined) {
                    const key = shortid.generate()
                    const startingPosition = Geometry.add(step.omegastage.units[unitKey].position, {"x": -0.5, "y": -0.5, "z": 1})
                    keyframes.push({
                        "mark": HIT_MARK,
                        "key": key,
                        "type": "particle",
                        "image": particleImages[deltaunit.health],
                        "position": startingPosition,
                    })
                    keyframes.push({
                        "mark": HIT_MARK + 600,
                        "key": key,
                        "type": "particle",
                        "timing": Timings.easeOutQuad,
                        "position": Geometry.add(startingPosition, {"z": +0.4}),
                        "delete": true,
                    })

                    const annotation = deltastage.annotation
                    if(annotation != undefined
                    && annotation.effectiveness !== undefined
                    && effectivenessImages[deltastage.annotation.effectiveness] != undefined) {
                        const key2 = shortid.generate()
                        keyframes.push({
                            "mark": HIT_MARK,
                            "key": key2,
                            "type": "particle",
                            "image": effectivenessImages[annotation.effectiveness],
                            "position": Geometry.add(startingPosition, {"z": -0.1}),
                        })
                        keyframes.push({
                            "mark": HIT_MARK + 600,
                            "key": key2,
                            "type": "particle",
                            "timing": Timings.easeOutQuad,
                            "position": Geometry.add(startingPosition, {"z": +0.4 + -0.1}),
                            "delete": true,
                        })
                    }
                }
                // EFFECTIVENESS //
                if(deltastage.annotation != undefined
                && deltastage.annotation.effectiveness !== undefined
                && effectivenessSounds[deltastage.annotation.effectiveness] != undefined) {
                    keyframes.push({
                        "type": "audio",
                        "mark": HIT_MARK,
                        "audio": {"triggerKey": effectivenessSounds[deltastage.annotation.effectiveness]},
                    })
                }
                // these are from annotation.type == bump, now obsolete?
                // keyframes.push({
                //     "key": unitKey,
                //     "mark": HIT_MARK,
                //     "position": Geometry.zero(),
                // })
                // keyframes.push({
                //     "key": unitKey,
                //     "mark": HIT_MARK + 150,
                //     "health": deltaunit.health,
                //     "position": {
                //         "x": 0.25 * deltastage.annotation.direction.x,
                //         "y": 0.25 * deltastage.annotation.direction.y
                //     },
                //     "timing": Timings.easeOutQuad,
                // })
                // keyframes.push({
                //     "key": unitKey,
                //     "mark": HIT_MARK + 300,
                //     "position": {"x": 0, "y": 0},
                //     "timing": Timings.easeOutQuad,
                // })
            })
        }
        if(deltastage.annotation.type == "bump-into") {
            Keyset.forEach(deltastage.units, (deltaunit, unitKey) => {
                keyframes.push({
                    "key": unitKey,
                    "mark": HIT_MARK
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": HIT_MARK + 150,
                    "health": deltaunit.health,
                })
            })
        }
        if(deltastage.annotation.type == "push") {
            Keyset.forEach(deltastage.units, (deltaunit, unitKey) => {
                keyframes.push({
                    "key": unitKey,
                    "mark": HIT_MARK,
                    "position": Geometry.zero(),
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": HIT_MARK + 300,
                    "timing": Timings.easeOutQuad,
                    "position": deltaunit.position, // assuming deltaunit.mode == "relative"
                })
            })
        }
        if(deltastage.annotation.type == "nudge") {
            keyframes = keyframes.concat([
                {
                    "key": deltastage.annotation.unitKey,
                    "mark": HIT_MARK,
                    "position": Geometry.zero(),
                },
                {
                    "key": deltastage.annotation.unitKey,
                    "mark": HIT_MARK + 150,
                    "position": {
                        "x": 0.25 * deltastage.annotation.direction.x,
                        "y": 0.25 * deltastage.annotation.direction.y
                    },
                    "timing": Timings.easeOutQuad,
                },
                {
                    "key": deltastage.annotation.unitKey,
                    "mark": HIT_MARK + 300,
                    "position": Geometry.zero(),
                    "timing": Timings.easeOutQuad,
                },
            ])
        }

        if(deltastage.annotation.type == "burst") {
            const startingPosition = Geometry.add(deltastage.annotation.startingPosition, {"x": -0.5, "y": -0.5, "z": 0.3})
            for(let i = 0; i < 1; i += 0.1) {
                const key = shortid.generate()
                const particlePosition = Geometry.add(
                    startingPosition,
                    Geometry.multiply(deltastage.annotation.direction, i),
                    // Geometry.multiply(Geometry.unit(deltastage.annotation.direction), Math.sign() * Math.random()),
                    {
                        "x": Random.sign() * Random.range(0, 0.15),
                        "y": Random.sign() * Random.range(0, 0.15),
                    }
                )
                const scale = 1 + Math.random()
                // "position": Geometry.add(deltastage.annotation.position, CENTER_OFFSET, {
                //     "x": (Random.range(0, 0.4)) * Random.sign(),
                //     "y": (Random.range(0, 0.4)) * Random.sign(),
                // }),
                keyframes.push({
                    "type": "audio",
                    "mark": HIT_MARK + ((i * 200) + (Math.random() * 50)),
                    "audio": {"triggerKey": "Aoe-er:Explosion"},
                })
                keyframes.push({
                    "mark": HIT_MARK + ((i * 200) + (Math.random() * 50)),
                    "key": key,
                    "type": "particle",
                    "image": require("@frog/source/images/ld47/characterUnit4_swirl.png"),
                    "position": particlePosition,
                    "rotation": Math.random() * 360,
                    "scale": scale,
                })
                // keyframes.push({
                //     "mark": HIT_MARK + 500 + 100,
                //     "key": key,
                //     "type": "particle",
                //     "position": Geometry.add(particlePosition, {
                //         "x": Random.sign() * Math.random() * 0.15,
                //         "y": Random.sign() * Math.random() * 0.15,
                //     }),
                //     "scale": scale,
                // })
                keyframes.push({
                    "mark": HIT_MARK + (200 + 50) + (150 + (i * 50) + (Math.random() * 100)),
                    "key": key,
                    "type": "particle",
                    "timing": Timings.easeInQuad,
                    // "position": startingPosition,
                    "scale": 0,
                    "rotation": 360 + 360 + Math.random() * 360,
                    "delete": true,
                })
            }
        }
    })
    return {keyframes}
}

animations["charge"] = (step) => {
    const keyframes = []
    const chargedDeltastage = step.deltastages.find((deltastage) => deltastage.annotation && deltastage.annotation.type == "charge")
    const pushedDeltastage = step.deltastages.find((deltastage) => deltastage.annotation && deltastage.annotation.type == "push")
    if(chargedDeltastage == undefined) return {keyframes}
    const speed = 100
    const chargeDistance = chargedDeltastage.annotation.distance
    const pushDistance = pushedDeltastage != undefined ? pushedDeltastage.annotation.distance : 0
    const hitMark = chargeDistance * speed
    const pushMark = hitMark + (pushDistance * speed)
    step.deltastages.forEach((deltastage) => {
        Keyset.forEach(deltastage.units, (deltaunit, unitKey) => {
            if(deltastage.annotation.type == "charge") {
                keyframes.push({
                    "key": unitKey,
                    "mark": 0,
                    "position": Geometry.zero(),
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": hitMark,
                    "position": deltaunit.position,  // assuming deltaunit.mode == "relative"
                    "timing": Timings.easeInQuad,
                    // TODO: what if no charge up, just attack?
                })
            }
            if(deltastage.annotation.type == "inflict damage") {
                keyframes.push({
                    "key": unitKey,
                    "mark": 0,
                    "health": 0,
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": hitMark,
                    "health": deltaunit.health
                })
                // keyframes.push({
                //     "key": "log",
                //     "type": "log",
                //     "mark": hitMark,
                //     "text": (step.alphastage.units[unitKey].name || "Box") + " takes " + (-1 * deltaunit.health) + " damage"
                // })
                // TODO: what if attacked without pushback? where to animate the bump
            }
            if(deltastage.annotation.type == "push") {
                keyframes.push({
                    "key": unitKey,
                    "mark": hitMark+1,
                    "position": {"x": 0, "y": 0, "z": 0},
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": pushMark,
                    "position": Geometry.add(deltaunit.position, Geometry.multiply(deltastage.annotation.direction, 0.25)),
                    "timing": pushDistance == chargeDistance ? Timings.easeOutQuad : Timings.linear,
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": pushMark + 150,
                    "position": deltaunit.position,
                    "timing": pushDistance == chargeDistance ? Timings.easeOutQuad : Timings.linear,
                })
            }
            if(deltastage.annotation.type == "inflict collision damage") {
                keyframes.push({
                    "key": unitKey,
                    "mark": 0,
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": pushMark,
                    "health": deltaunit.health
                })
                // keyframes.push({
                //     "key": "log",
                //     "type": "log",
                //     "mark": pushMark,
                //     "text": (step.alphastage.units[unitKey].name || "Box") + " takes " + (-1 * deltaunit.health) + " collision damage"
                // })
            }
        })
    })
    return {keyframes}
}

// function attackingFrames() {
//     return [
//         {
//             "mark": 0.00,
//             "units": {
//                 [deltaperformer.key]: {
//                     "position": {"x": 0, "y": 0},
//                     "rotate": 0,
//                 },
//             },
//         },
//         {
//             "mark": 0.15,
//             "units": {
//                 [deltaperformer.key]: {
//                     "position": {"x": -0.25 * direction.x, "y": -0.25 * direction.y},
//                     "rotate": -45 * (direction.x <= 0 ? -1 : +1),
//                 },
//             },
//         },
//         {
//             "mark": 0.30,
//             "units": {
//                 [deltaperformer.key]: {
//                     "position": {"x": -0.25 * direction.x, "y": -0.25 * direction.y},
//                     "rotate": -45 * (direction.x <= 0 ? -1 : +1),
//                 },
//             },
//         },
//         {
//             "mark": 0.50,
//             "event": "onContact",
//             "audio": "Unit:Damage",
//             "units": {
//                 [deltaperformer.key]: {
//                     "position": {"x": +0.125 * direction.x, "y": +0.125 * direction.y},
//                     "rotate": +45 * (direction.x <= 0 ? -1 : +1),
//                 },
//                 [deltatarget.key]: {
//                     "position": {"x": 0, "y": 0},
//                     "rotate": 0
//                 },
//             },
//         },
//         {
//             "mark": 0.75,
//             "units": {
//                 [deltaperformer.key]: {
//                     "position": {"x": +0.125 * direction.x, "y": +0.125 * direction.y},
//                     "rotate": +45 * (direction.x <= 0 ? -1 : +1),
//                 },
//                 [deltatarget.key]: {
//                     "position": {"x": +0.25 * direction.x, "y": +0.25 * direction.y},
//                     "rotate": 0,
//                 },
//             },
//         },
//         {
//             "mark": 1.00,
//             "units": {
//                 [deltaperformer.key]: {
//                     "position": {"x": 0, "y": 0},
//                     "rotate": 0,
//                 },
//                 [deltatarget.key]: {
//                     "position": {"x": 0, "y": 0},
//                     "rotate": 0
//                 },
//             },
//         },
//     ]
// }

function attackedFrames({startingMark, unitKey, direction}) {
    return [
        {
            "key": unitKey,
            "mark": startingMark,
            "event": "onContact",
            "audio": "Unit:Damage",
            "position": {"x": 0, "y": 0},
            "rotate": 0
        },
        {
            "key": unitKey,
            "mark": startingMark + 100,
            "position": {"x": +0.25 * direction.x, "y": +0.25 * direction.y},
            "timing": Timings.easeOutQuad,
            "rotate": 0,
        },
        {
            "key": unitKey,
            "mark": startingMark + 200,
            "position": {"x": 0, "y": 0},
            "timing": Timings.easeOutQuad,
            "rotate": 0
        },
    ]
}


animations["readytrap"] = (step) => {
    // NO ACTUAL STAGE STATE HAPPENS HERE, JUST ANIMATION
    let keyframes = []
    step.deltastages.forEach((deltastage) => {
        if(deltastage.annotation != undefined
        && deltastage.annotation.type == "attacking") {
            keyframes = keyframes.concat(attackedFrames({
                "startingMark": 0,
                "unitKey": deltastage.annotation.unitKey,
                "direction": deltastage.annotation.direction,
            }))
            return
        }
    })
    return {keyframes}
}

animations["leap"] = (step) => {
    const distance = 2 // TODO: calculate this! and as a magnitude, not a vector.
    const FIRE_MARK = 300
    const HIT_MARK = FIRE_MARK + (300 * distance)
    const keyframes = []
    step.deltastages.forEach((deltastage) => {
        if(deltastage.annotation.type == "leap") {
            keyframes.push({
                "mark": 0,
                "key": deltastage.annotation.unitKey,
                "position": Geometry.zero(),
            })
            keyframes.push({
                "mark": 200,
                "key": deltastage.annotation.unitKey,
                "position": {"z": -0.125},
                "timing": Timings.easeOutQuad,
            })
            keyframes.push({
                "mark": FIRE_MARK,
                "key": deltastage.annotation.unitKey,
                "position": {"z": -0.125},
                "timing": Timings.easeOutQuad,
            })
            // keyframes.push({
            //     "mark": FIRE_MARK,
            //     "key": deltastage.annotation.unitKey,
            //
            //     "position": Geometry.add(deltastage.annotation.startPosition, CENTER_OFFSET),
            // })
            keyframes.push({
                "mark": HIT_MARK,
                "key": deltastage.annotation.unitKey,
                "timing": Timings.bezier(0.3, 1-0.25, 1-0.3, 0.25),
                "motion": Motions.arc(),
                "position": deltastage.annotation.vector,
            })
        }
        if(deltastage.annotation.type == "bump") {
            Keyset.forEach(deltastage.units, (deltaunit, unitKey) => {
                keyframes.push({
                    "key": unitKey,
                    "mark": HIT_MARK,
                    "position": Geometry.zero(),
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": HIT_MARK + 150,
                    "health": deltaunit.health,
                    "position": {
                        "x": 0.25 * deltastage.annotation.direction.x,
                        "y": 0.25 * deltastage.annotation.direction.y
                    },
                    "timing": Timings.easeOutQuad,
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": HIT_MARK + 300,
                    "position": {"x": 0, "y": 0},
                    "timing": Timings.easeOutQuad,
                })
            })
        }
    })
    return {keyframes}
}

const SHOCK_SHAKE_COUNT = 10
const SHOCK_SHAKE_TIME = 40
animations["shock"] = (step) => {
    let keyframes = []
    const hitMark = 0
    step.deltastages.forEach((deltastage) => {
        Keyset.forEach(deltastage.units, (deltaunit, unitKey) => {
            if(deltastage.annotation == undefined) {
                return
            }
            // if(deltastage.annotation.type == "swing") {
            //     keyframes = keyframes.concat(swingAnimation(unitKey, deltastage.annotation.direction, hitMark))
            // }
            if(deltastage.annotation.type == "shock") {
                const delay = deltastage.annotation.distance * ((SHOCK_SHAKE_COUNT * 0.5) * SHOCK_SHAKE_TIME)
                keyframes.push({
                    "key": unitKey,
                    "mark": hitMark,
                    "health": 0,
                    "position": Geometry.zero(),
                })
                keyframes.push({
                    "key": unitKey,
                    "mark": hitMark + delay,
                    "health": deltaunit.health,
                    "position": Geometry.zero(),
                })
                for(let i = 0; i < SHOCK_SHAKE_COUNT; i += 1) {
                    keyframes.push({
                        "key": unitKey,
                        "mark": hitMark + delay + (i * SHOCK_SHAKE_TIME),
                        "position": {
                            "x": ((Math.random() * 2) - 1) * 0.25,
                            "y": ((Math.random() * 2) - 1) * 0.25,
                        },
                        "timing": Timings.linear,
                    })
                }
                keyframes.push({
                    "key": unitKey,
                    "mark": hitMark + delay + (SHOCK_SHAKE_COUNT * SHOCK_SHAKE_TIME),
                    "position": Geometry.zero(),
                    "timing": Timings.linear,
                })
            }
        })
    })
    return {keyframes}
}
